import { render, staticRenderFns } from "./FileImport.vue?vue&type=template&id=50f68856&scoped=true&"
import script from "./FileImport.vue?vue&type=script&lang=js&"
export * from "./FileImport.vue?vue&type=script&lang=js&"
import style0 from "./FileImport.vue?vue&type=style&index=0&id=50f68856&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f68856",
  null
  
)

export default component.exports